import React, { useState, useEffect, useCallback } from 'react';
import { Row, message } from 'antd';
import moment from 'moment';

import { getFiltrarAtendimento } from '../../services';
import { Filtros } from './Filtros';
import { TabelaListagem } from './TebelaListagem';
import { ModalDetalhamento } from './ModalDetalhamento';
import * as S from './styles';

export function Historico() {
  const [solicitacoes, setSolicitacoes] = useState({});
  const [filtros, setFiltros] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
  });
  const [loading, setLoading] = useState(false);
  const [stateModal, setStateModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const buscarSolicitacoes = useCallback(async () => {
    setSolicitacoes({});
    setLoading(true);

    const dateNow = new Date();
    const dataInicio = moment(dateNow)
      .subtract(0, 'days')
      .format('YYYY-MM-DD 00:00');
    const dataFim = moment(dateNow)
      .add(1, 'days')
      .format('YYYY-MM-DD 00:00');

    const isInitGet = `DataInicio=${dataInicio}&DataFim=${dataFim}&PageSize=${pagination?.pageSize}&PageNumber=${pagination?.current}`;
    const isFiltered = `${filtros}&PageSize=${pagination?.pageSize}&PageNumber=${pagination?.current}`;

    const payloadformated = filtros ? isFiltered : isInitGet;

    const response = await getFiltrarAtendimento(payloadformated);

    if (response?.status === 200) {
      setLoading(false);
      return handlerFiltrar(response);
    }

    if (response?.status !== 200) {
      setLoading(false);
      return message.error(
        response?.error?.response?.data?.detail || 'Error ao carregar dados.'
      );
    }
    setLoading(false);
  }, [filtros, pagination]);

  const handlerFiltrar = response => {
    setSolicitacoes(response);
  };

  const handlerModalOpen = (data = {}) => {
    setStateModal(true);
    return setDataModal(data?.data);
  };

  const handlerModalClose = () => {
    setStateModal(false);
    return setDataModal(null);
  };

  useEffect(() => {
    (async () => {
      await buscarSolicitacoes();
    })();
  }, [filtros, pagination, buscarSolicitacoes]);

  const clearFilter = () => {
    setPagination({ current: 1, pageSize: 15 });
    setFiltros(null);
  };

  return (
    <Row style={{ padding: '15px 22px 0 26px' }} id="page-historico">
      {dataModal && (
        <ModalDetalhamento
          visible={stateModal}
          handlerModal={handlerModalClose}
          dataModal={dataModal}
        />
      )}
      <S.Section justify="center">
        <S.SectionBloco padding="12px 0 17px 17px">
          <Row justify="space-between">
            <S.TitulePage>Histórico de solicitações</S.TitulePage>
          </Row>
        </S.SectionBloco>
      </S.Section>
      <S.Section justify="center">
        <S.SectionBloco padding="20px 16px 40px 16px">
          <Filtros
            handerFiltrar={handlerFiltrar}
            isClearFilter={clearFilter}
            paramsFilter={setFiltros}
            paginationFilter={setPagination}
            loading={loading}
          />
          <Row style={{ minHeight: '33rem', marginTop: '62px' }}>
            <TabelaListagem
              dataSource={solicitacoes}
              openModal={handlerModalOpen}
              loading={loading}
              pageProps={setPagination}
              recarregar={buscarSolicitacoes}
            />
          </Row>
        </S.SectionBloco>
      </S.Section>
    </Row>
  );
}
